import { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

// Components
import { Button, Panel, Text } from '../..'
import BotHead from '../../shared/Avatar/BotHeadColored'

// Styles
import styles from './NoLoansPanel.module.scss'

const propTypes = {
  addLoan: PropTypes.func,
  currentHelocCount: PropTypes.number,
  markPaidInFull: PropTypes.func,
}

const NoLoansPanel = ({ addLoan, currentHelocCount, markPaidInFull }) => {
  const [hide, setHide] = useState(false)

  const containerClass = classnames(styles.root, {
    [styles.hide]: hide,
  })

  return (
    <Panel data-qa='NoLoansCard' className={containerClass}>
      <BotHead quizzical type='error' size='l' />
      <Panel.Heading color='warning'>
        {currentHelocCount > 0 && (
          <FormattedMessage
            id='NoLoans.heading.onlyHelocs'
            defaultMessage='Do we have all of your loans?'
          />
        )}

        {!currentHelocCount && (
          <FormattedMessage
            id='NoLoans.heading.nothing'
            defaultMessage='Do you have any loans?'
          />
        )}
      </Panel.Heading>
      <Text
        variant='neutralCool'
        variantCount='700'
        size='s'
        className={styles.description}
      >
        {currentHelocCount > 0 && (
          <FormattedMessage
            id='NoLoans.description.onlyHelocsHTML'
            defaultMessage="We've searched public records and found a HELOC.{br}Adding your conventional loans if you have them will make Homebot more accurate."
            values={{ br: <br /> }}
          />
        )}

        {!currentHelocCount && (
          <FormattedMessage
            id='NoLoans.description.nothingHTML'
            defaultMessage="We've searched public records and have come up empty!{br}Adding a couple loan details makes Homebot more accurate."
            values={{ br: <br /> }}
          />
        )}
      </Text>
      <Button.Group className={styles.buttons}>
        <Button primary onClick={addLoan}>
          <FormattedMessage
            id='NoLoans.button.addLoan'
            defaultMessage='Add a loan'
          />
        </Button>
        {hide && (
          <div>
            <Button loading />
          </div>
        )}
        {!hide && (
          <Button
            onClick={() => {
              markPaidInFull()
              setHide(true)
            }}
          >
            {!hide && currentHelocCount > 0 && (
              <FormattedMessage
                id='NoLoans.button.onlyHelocs'
                defaultMessage="I don't have more loans"
              />
            )}
            {!hide && !currentHelocCount && (
              <FormattedMessage
                id='NoLoans.button.nothing'
                defaultMessage="I don't have loans"
              />
            )}
          </Button>
        )}
      </Button.Group>
      <Button minimal element='a' href='https://homebot.ai/privacy-policy'>
        <FormattedMessage
          id='NoLoans.button.privacy'
          defaultMessage='Read our privacy policy'
        />
      </Button>
    </Panel>
  )
}

NoLoansPanel.propTypes = propTypes

export default NoLoansPanel
